import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Grid, Select, Button, Form } from 'semantic-ui-react';
import * as _ from 'lodash';

import { ReportGeneration } from 'Common/ObjectHelper';
import { defaultDateFormat } from 'Common/GeneralHelper';
import { createToast, toastType } from 'Common/ToastHelper';
import { Filter, Main } from 'Containers';
import {
  getCalendars,
  getReport,
  clearReport,
  getControlInfo,
} from './state/actions';
import * as Enumeration from './helpers/Enumeration';
import * as ButtonType from './helpers/ButtonType';
import { TitledCard } from 'Components';

class MBEReportContainer extends Component {
  state = {
    reportType: Enumeration.ReportTypeEnum.Scheduled,
    sortType: Enumeration.SortTypeEnum.LastName,
    groupType: Enumeration.GroupTypeEnum.None,
    provisionType: Enumeration.ProvisionTypeEnum.Both,
    carryoverType: Enumeration.CarryoverType.YearEnd,
    fiscalYear: '',
    calendar: '',
    school: '',
    fiscalYearList: [],
    calendarList: [],
    schoolList: [],
  };

  componentDidMount() {
    this.props.getCalendars();
    this.props.getControlInfo();
  }

  componentDidUpdate(prevProps) {
    const { calendarData, controlInfo, report } = this.props;
    const { calendar, school, calendarList, schoolList } = this.state;

    if (prevProps.calendarData.length === 0 && calendarData.length > 0) {
      const fiscalYearList = calendarData.map(element => {
        return {
          value: element.FiscalYear,
          text: element.FiscalYear,
        };
      });
      this.setState(
        {
          fiscalYearList: _.uniqWith(fiscalYearList, (arrVal, othVal) => {
            return arrVal.value === othVal.value;
          }),
        },
        this.yearChanged
      );
    }

    if (schoolList.length > 0 && school === '') {
      this.setState({
        school: schoolList.length > 1 ? 'all' : schoolList[0].value,
      });
    }

    if (calendarList.length > 0 && calendar === '') {
      this.setState(
        {
          calendar: calendarList.length > 1 ? 'all' : calendarList[0].value,
        },
        this.calendarChanged
      );
    }

    if (prevProps.controlInfo !== controlInfo) {
      this.setState(
        {
          provisionType: controlInfo.ProvisionTypeDefault,
          fiscalYear: controlInfo.FiscalYear,
        },
        this.yearChanged
      );
    }

    if (report !== '' && prevProps.report === '') {
      if (report === 'No Data') {
        createToast(toastType.info, 'Results', 'No data found!', true);
      } else {
        ReportGeneration(report, 'Meal Benefits Expiration');
      }

      this.props.clearReport();
    }
  }

  isValidCalendar(calendar) {
    return (
      calendar.FiscalYear === this.state.fiscalYear &&
      ((this.state.reportType === Enumeration.ReportTypeEnum.Scheduled &&
        calendar.MbeComplete === false) ||
        (this.state.reportType === Enumeration.ReportTypeEnum.Expired &&
          calendar.MbeComplete === true))
    );
  }

  yearChanged() {
    const calendarsInYear = this.props.calendarData.filter(calendar => {
      return this.isValidCalendar(calendar);
    });

    let calendarList = calendarsInYear.map(calendar => {
      return {
        value: calendar.Id,
        text:
          calendar.Description +
          ` (${
            calendar.MealExpirationDT === null
              ? 'MBE Not Enabled'
              : defaultDateFormat(calendar.MealExpirationDT)
          })`,
      };
    });

    if (calendarList.length > 1)
      calendarList = [{ value: 'all', text: 'All' }, ...calendarList];

    this.setState({
      calendarList,
    });
  }

  findCalendarObject() {
    if (this.state.calendar === 'all') {
      const combinedSiteList = [];
      this.props.calendarData.forEach(calendar => {
        if (!this.isValidCalendar(calendar)) return;

        calendar.SchoolCalendarSiteMasters.forEach(site => {
          if (site.IsLicensed) combinedSiteList[site.SiteMasterId] = site;
        });
      });

      return {
        Description: 'All',
        SchoolCalendarSiteMasters: _.compact(combinedSiteList).map(element => {
          return element;
        }),
      };
    }

    return this.props.calendarData.find(object => {
      return object.Id === this.state.calendar;
    });
  }

  calendarChanged() {
    const selectedCalendar = this.findCalendarObject();

    let schoolList = selectedCalendar.SchoolCalendarSiteMasters.filter(site => {
      return site.Assigned && site.IsLicensed;
    }).map(site => {
      return {
        value: site.SiteMasterId,
        text: site.SiteMasterId + ' ' + site.SiteDescription,
      };
    });

    if (schoolList.length > 1)
      schoolList = [{ value: 'all', text: 'All' }, ...schoolList];

    this.setState({
      school: '',
      schoolList,
    });
  }

  viewReport = () => {
    const {
      provisionType,
      reportType,
      groupType,
      calendar,
      school,
      sortType,
      fiscalYear,
      carryoverType,
    } = this.state;
    const selectedCalendar = this.findCalendarObject();

    if (calendar === '' || school === '') {
      return createToast(
        toastType.error,
        'Error',
        'Calendar and School Must be Selected',
        true
      );
    }

    const postData = {
      isScheduled: reportType === Enumeration.ReportTypeEnum.Scheduled,
      isCEP:
        provisionType === Enumeration.ProvisionTypeEnum.CEP ||
        provisionType === Enumeration.ProvisionTypeEnum.Both,
      isTraditional:
        provisionType === Enumeration.ProvisionTypeEnum.Traditional ||
        provisionType === Enumeration.ProvisionTypeEnum.Both,
      groupBySchool: groupType === Enumeration.GroupTypeEnum.School,
      calendarId: calendar,
      calendarDesc: selectedCalendar.Description,
      schoolId: school,
      schoolDesc: _.defaultTo(
        _.find(selectedCalendar.SchoolCalendarSiteMasters, object => {
          return object.SiteMasterId === school;
        }),
        { SiteDescription: 'All' }
      ).SiteDescription,
      sortBy: sortType,
      fiscalYear,
      carryoverType,
    };

    this.props.getReport(postData);
  };

  schoolChanged = (e, { value }) => this.setState({ school: value });

  getMainProps = () => {
    const { isFetching } = this.props;

    return {
      toolbox: {
        rightButtons: [
          {
            content: 'View',
            onClick: this.viewReport,
            disabled: isFetching,
            loading: isFetching,
          },
        ],
        shown: true,
      },
    };
  };

  render() {
    const { isFetching } = this.props;
    return (
      <Fragment>
        <Filter title="Meal Benefit Expiration Report" />
        <Main {...this.getMainProps()}>
          <div className="card-indent">
            <Grid>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <label className="text-orange">Report Type</label>
                  <Button.Group basic className="btn-group--active-group">
                    {ButtonType.ReportType.map(type => (
                      <Button
                        basic
                        key={type.type}
                        className="white"
                        active={this.state.reportType === type.type}
                        onClick={() =>
                          this.setState(
                            {
                              reportType: type.type,
                              calendarList: [],
                              schoolList: [],
                              school: '',
                              calendar: '',
                            },
                            this.yearChanged
                          )
                        }
                        disabled={isFetching}
                      >
                        {type.text}
                      </Button>
                    ))}
                  </Button.Group>
                </Grid.Column>
                <Grid.Column>
                  <label className="text-orange">Group By</label>
                  <Button.Group basic className="btn-group--active-group">
                    {ButtonType.GroupBy.map(type => (
                      <Button
                        basic
                        key={type.type}
                        className="white"
                        active={this.state.groupType === type.type}
                        onClick={() => this.setState({ groupType: type.type })}
                        disabled={isFetching}
                      >
                        {type.text}
                      </Button>
                    ))}
                  </Button.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <label className="text-orange">Sort By</label>
                  <Button.Group basic className="btn-group--active-group">
                    {ButtonType.SortType.map(type => (
                      <Button
                        basic
                        key={type.type}
                        className="white"
                        active={this.state.sortType === type.type}
                        onClick={() => this.setState({ sortType: type.type })}
                        disabled={isFetching}
                      >
                        {type.text}
                      </Button>
                    ))}
                  </Button.Group>
                </Grid.Column>
                <Grid.Column>
                  <label className="text-orange">Provision Type</label>
                  <Button.Group basic className="btn-group--active-group">
                    {ButtonType.ProvisionType.map(type => (
                      <Button
                        basic
                        key={type.type}
                        className="white"
                        active={this.state.provisionType === type.type}
                        onClick={() =>
                          this.setState({ provisionType: type.type })
                        }
                        disabled={isFetching}
                      >
                        {type.text}
                      </Button>
                    ))}
                  </Button.Group>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row columns={2}>
                <Grid.Column>
                  <label className="text-orange">Carryover Type</label>
                  <Button.Group basic className="btn-group--active-group">
                    {ButtonType.CarryoverType.map(type => (
                      <Button
                        basic
                        key={type.type}
                        className="white"
                        active={this.state.carryoverType === type.type}
                        onClick={() =>
                          this.setState({ carryoverType: type.type })
                        }
                        disabled={isFetching}
                      >
                        {type.text}
                      </Button>
                    ))}
                  </Button.Group>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </div>
          <TitledCard title={'Filter By'}>
            <Form>
              <Grid>
                <Grid.Row columns={2}>
                  <Grid.Column className="input-group--btn-group">
                    <label>Fiscal Year</label>
                    <Select
                      disabled={
                        this.state.fiscalYearList.length === 0 ||
                        isFetching ||
                        this.state.reportType ===
                          Enumeration.ReportTypeEnum.Scheduled
                      }
                      options={this.state.fiscalYearList}
                      onChange={(e, { value }) =>
                        this.setState({ fiscalYear: value }, this.yearChanged)
                      }
                      value={this.state.fiscalYear}
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <label>Calendar</label>
                    <Select
                      fluid
                      disabled={
                        this.state.calendarList.length === 0 || isFetching
                      }
                      options={this.state.calendarList}
                      onChange={(e, { value }) =>
                        this.setState({ calendar: value }, this.calendarChanged)
                      }
                      value={this.state.calendar}
                      placeholder="No Data Loaded"
                    />
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row columns={3}>
                  <Grid.Column>
                    <label>School</label>
                    <Select
                      className={'shorter'}
                      fluid
                      disabled={
                        this.state.schoolList.length === 0 || isFetching
                      }
                      options={this.state.schoolList}
                      onChange={this.schoolChanged}
                      value={this.state.school}
                      placeholder="No Data Loaded"
                    />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Form>
          </TitledCard>
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    calendarData: state.MBEReportState.calendarData,
    isFetching: state.MBEReportState.isFetching,
    fetchError: state.MBEReportState.fetchError,
    report: state.MBEReportState.report,
    controlInfo: state.MBEReportState.controlInfo,
  };
};

const mapDispatch = {
  getCalendars,
  getReport,
  clearReport,
  getControlInfo,
};

export const MBEReport = withRouter(
  connect(mapStateToProps, mapDispatch)(MBEReportContainer)
);



// WEBPACK FOOTER //
// ./src/pages/mbereport/MBEReport.js